<template>
  <div className="privacy-policy-container">
    <h1>waySway iOS Privacy Policy</h1>

    <h2>Data Collection</h2>
    <p>
      We collect personal data (username, email) and usage data (viewed videos, bookmarks, itineraries) to provide and
      personalize the app experience. Location data is used for geotagged content and travel planning.
    </p>

    <h2>Geolocation Services</h2>
    <p>
      The app uses GPS/Wi-Fi to offer location-relevant content and generate plans. Users can manage location access in
      iOS Settings.
    </p>

    <h2>Third-Party Integrations</h2>
    <p>
      We may interface with booking platforms, social media, etc. Data shared and respective privacy policies will be
      disclosed.
    </p>

    <h2>Data Retention & Deletion</h2>
    <p>
      User data is stored for a defined period. Users can request data deletion, rectification, or access per GDPR/CCPA.
    </p>

    <h2>Security Measures</h2>
    <p>
      We implement strong security measures (encryption, access controls) and respond promptly to potential breaches.
    </p>

    <h2>Children's Privacy</h2>
    <p>
      If applicable, we comply with COPPA and handle children's data (users under 13) appropriately, including parental
      consent mechanisms.
    </p>

    <h2>Policy Updates</h2>
    <p>
      Users will be notified of material changes to the privacy policy. The latest version will always be available in
      the app or on our website.
    </p>

    <p>
      This policy adheres to Apple's App Store Review Guidelines, GDPR, CCPA, and other relevant data protection
      regulations.
    </p>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style scoped>
.privacy-policy-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

h1, h2 {
  color: #333;
}

p {
  font-size: 16px;
  color: #666;
  line-height: 1.5;
}
</style>
